import React from "react";
import { InputGroup, Form } from "react-bootstrap";

const PlbPaginatedModal = ({handlePlbPageChange,plbPaginatedata, formik, handleWheel, renderPlbClass, isViewOnllyGrid, totalPages }) => {
    const totalItems = formik.values?.plb_adjustments?.length || 0;
    const totalPageCount = Math.ceil(totalItems / plbPaginatedata?.pageSize);
    
    // Get paginated data
    const paginatedData = formik.values?.plb_adjustments?.slice((plbPaginatedata?.currentPage - 1) * plbPaginatedata?.pageSize, plbPaginatedata?.currentPage * plbPaginatedata?.pageSize);

    const getCurentIndex = (ind)=>{
        return ind+(plbPaginatedata?.currentPage-1)*plbPaginatedata?.pageSize
    }
    const plbTabFunction = (index,e)=>{
        if(index===14&&totalPageCount>1&&e.shiftKey===false&&e.key==='Tab'){
            handlePlbPageChange(plbPaginatedata?.currentPage+1)
            setTimeout(()=>{
                const plbContainer = document.querySelector('.plb-main-component-container')
                plbContainer&&plbContainer.querySelector('input').focus()
            },100)
        }
    }
    return (
   
            <div className="plb-main-component-container" >
                <div className="row" >
                    {paginatedData?.length>0&&paginatedData?.map((plb, index) => (
                        <div className="col-lg-4" key={index}>
                            <div className="sub-section">
                            <div className="">
                                <div className="label-claim">
                                <button
                                    disabled={isViewOnllyGrid}
                                    type="button"
                                    tabIndex="-1"
                                //     onClick={() => {
                                //     handlePlbDeleteAmount(getCurentIndex(index));
                                //     handlePlbPaginatedCurrentPage(false,totalItems)
                                //     }}
                                    className="btn btn-outline-danger exclude-disabled-plb-button"
                                >
                                    ×
                                </button>
                                <span>    
                                    PLB Adj{" "}
                                </span>    
                                </div>
                            </div>
                            <div className="wrapper-plb plb-npi">
                                <InputGroup>
                                <InputGroup.Text>NPI </InputGroup.Text>
                                <Form.Control
                                    type="text"
                                    onChange={(e)=>{formik.setFieldValue(`plb_adjustments[${getCurentIndex(index)}].npi`, e.target?.value);}}
                                    className={renderPlbClass('npi', 'TEXT', 'w-npi', getCurentIndex(index))}
                                    value={plb?.npi}
                                    disabled={isViewOnllyGrid}
                                    maxLength={10}
                                    name={`plb_adjustments[${getCurentIndex(index)}].npi`}
                                //     onFocus={() => {componentType=='PAYMENT835'? setPlbOnFocus(true):"" }}
                                //     onBlur={() => { componentType=='PAYMENT835'?setPlbOnFocus(false):"" }}
                                //     tabIndex={componentType=='PAYMENT835'?plbOnFocus ? 0 : -1:0}
                                    autoComplete="one-time-code"
                                    data-plb-index={index}
                                />
                                </InputGroup>
                            </div>
        
                            <div className="wrapper-add plb-page">
                                <InputGroup>
                                <InputGroup.Text>PAGE</InputGroup.Text>
                                <Form.Control
                                    as="select"
                                    type="text"
                                    onChange={(e)=>{formik.setFieldValue(`plb_adjustments[${getCurentIndex(index)}].plb_page`, e.target?.value);}}
                                    value={plb?.plb_page}
                                    disabled={isViewOnllyGrid}
                                    className={renderPlbClass('plb_page', 'NUMBER', 'w-patient', getCurentIndex(index))}
                                    name={`plb_adjustments[${getCurentIndex(index)}].plb_page`}
                                    // tabIndex={plb?.plb_page != '' && pathname == DATA_ENTRY ? -1 : 0}
                                //     onFocus={() => {componentType=='PAYMENT835'? setPlbOnFocus(true):"" }}
                                //     onBlur={() => { componentType=='PAYMENT835'?setPlbOnFocus(false):"" }}
                                //     tabIndex={componentType=='PAYMENT835'?plbOnFocus ? 0 : -1:0}
                                >
                                    {/* <option value="0">---select---</option> */}
                                    {Array.from(Array(totalPages).keys()).map(
                                    (i, ind) => (
                                        <option key={ind} value={i + 1}>
                                        {i + 1}
                                        </option>
                                    )
                                    )}
                                </Form.Control>
                                </InputGroup>
                            </div>
                            <div className="wrapper-add plb-rsn">
                                <InputGroup>
                                <InputGroup.Text>RSN</InputGroup.Text>
                                <Form.Control
                                    as="select"
                                    type="text"
                                    onChange={(e)=>{formik.setFieldValue(`plb_adjustments[${getCurentIndex(index)}].reason`, e.target?.value);}}
                                    value={plb?.reason}
                                //     onFocus={() => {componentType=='PAYMENT835'? setPlbOnFocus(true):"" }}
                                //     onBlur={() => { componentType=='PAYMENT835'?setPlbOnFocus(false):"" }}
                                //     tabIndex={componentType=='PAYMENT835'?plbOnFocus ? 0 : -1:0}
                                    className={renderPlbClass('reason', 'STRING', 'select-pan', getCurentIndex(index))}
                                    name={`plb_adjustments[${getCurentIndex(index)}].reason`}
                                    disabled={isViewOnllyGrid}
                                >
                                      {plbPaginatedata?.reasonOptions.map(option => (
                                        <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                </Form.Control>
                                </InputGroup>
                            </div>
                            <div className="wrap-pan plb-pat">
                                <InputGroup>
                                <InputGroup.Text>
                                    PAT#
                                </InputGroup.Text>
                                <Form.Control
                                    type="text"
                                    onChange={(e)=>{formik.setFieldValue(`plb_adjustments[${getCurentIndex(index)}].patient_account_number`, e.target?.value);}}
                                    value={
                                        plb?.patient_account_number
                                    }
                                    className={renderPlbClass('patient_account_number', 'TEXT', 'w-pat-a-n', getCurentIndex(index))}
                                    disabled={isViewOnllyGrid}
                                    name={`plb_adjustments[${getCurentIndex(index)}].patient_account_number`}
                                //     onFocus={() => {componentType=='PAYMENT835'? setPlbOnFocus(true):"" }}
                                //     onBlur={() => { componentType=='PAYMENT835'?setPlbOnFocus(false):"" }}
                                //     tabIndex={componentType=='PAYMENT835'?plbOnFocus ? 0 : -1:0}
                                    autoComplete="one-time-code"
                                />
                                </InputGroup>
                            </div>
                            <div className="wrap-amt plb-amt">
                                <InputGroup>
                                <InputGroup.Text>AMT</InputGroup.Text>
                                <Form.Control
                                    type="number"
                                //     onChange={(e) => handlePlbAmount(e, getCurentIndex(index))}
                                    onWheel={handleWheel}
                                //     onKeyDown={(e) => { handleKeyPress(e); handlePreventEKeyPress(e);plbTabFunction(index,e) }}
                                //     onDoubleClick={() => insertRemainingAmount(getCurentIndex(index))}
                                //     onFocus={() => {componentType=='PAYMENT835'? setPlbOnFocus(true):"" }}
                                //     onBlur={() => { componentType=='PAYMENT835'?setPlbOnFocus(false):"" }}
                                //     tabIndex={componentType=='PAYMENT835'?plbOnFocus ? 0 : -1:0}
                                    value={plb?.plb_amt}
                                    className={renderPlbClass('plb_amt', 'NUMBER', 'w-patient', getCurentIndex(index))}
                                    disabled={isViewOnllyGrid}
                                    name={`plb_adjustments[${getCurentIndex(index)}].plb_amt`}
                                />
                                </InputGroup>
                            </div>
                            </div>
                      </div>
                    ))}
                </div>
                </div>

    );
};

export default PlbPaginatedModal;
